export default {
      id: "ico-linkedin-usage",
      viewBox: "0 0 26 24",
      url: __webpack_public_path__ + "sprite.svg#ico-linkedin",
      toString: function () {
        return this.url;
      }
    }